// @flow
import Properties from "../../../Properties";
import {
  getInit,
  postInit,
  graphQLInit,
  putInit,
  deleteInit
} from "../../global/types/constants";
import type { DispatchType } from "../../global/types/redux";
import { apiFailCallbackHandle } from "../../account/containers/ErrosDisplay";
import {
  ADMIN_EDIT_COMPANY_FACEBASE,
  ADMIN_SET_FACEBASE_LIST,
  ADMIN_ADD_FACEBASE,
  ADMIN_UPDATE_FACEBASE,
  ADMIN_REMOVE_LICENCE_FROM_FACEBASE,
  ADMIN_DELETE_FACEBASE,
  ADMIN_UPDATE_FACEBASE_USER,
  EDIT_COMPANY_FACEBASE
} from "../../global/actions/actionNames";

const root = Properties.api_root;

export const fetchFacebaseList = (callback?: Function): * => (
  dispatch: DispatchType
): * => {
  return fetch(`${root}/auth/v2/facebases`, getInit)
    .then(response => response.json())
    .then(json => {
      dispatch({ type: ADMIN_SET_FACEBASE_LIST, facebases: json.facebases });
      callback && callback(json.facebases);
    });
};

export const fetchFacebase = (facebaseId: string, callback?: Function): * => (
  dispatch: DispatchType
): * => {
  return fetch(`${root}/auth/v2/facebases/${facebaseId}?detailed=true`, getInit)
    .then(response => response.json())
    .then(json => {
      dispatch({ type: ADMIN_ADD_FACEBASE, facebase: json.facebase });
      callback && callback(json.facebase);
    });
};

export function editFacebase(
  facebaseId: string,
  name: string,
  person_limit: string,
  online: boolean,
  newCompanyId: string,
  doneBack: Function,
  failBack: Function,
  companyId: string,
  reduxAction: string,
  model?: number
): * {
  let formData = new FormData();
  formData.append("name", name);
  formData.append("person_limit", person_limit);
  formData.append("online", online);
  model && formData.append("model", model);
  newCompanyId && formData.append("company_id", newCompanyId);
  return (dispatch: DispatchType) => {
    fetch(root + "/auth/v2/facebases/" + facebaseId, putInit(formData))
      .then(response => response.json())
      .then(function(json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors));
        } else {
          if (reduxAction === "adminFacebase") {
            dispatch({ type: ADMIN_UPDATE_FACEBASE, facebase: json.facebase });
          } else if (reduxAction === "adminCompany") {
            dispatch({
              type: ADMIN_EDIT_COMPANY_FACEBASE,
              facebase: json.facebase,
              companyId: companyId
            });
          } else if (reduxAction === "company") {
            dispatch({
              type: EDIT_COMPANY_FACEBASE,
              facebase: json.facebase
            });
          }
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message));
      });
  };
}

export function deleteFacebase(
  facebaseUuid: string,
  doneBack: Function,
  failBack: Function
): * {
  return (dispatch: any) => {
    fetch(root + "/auth/v2/facebases/" + facebaseUuid, deleteInit())
      .then(response => response.json())
      .then(function(json) {
        if (json.errors) {
          failBack && failBack(apiFailCallbackHandle(json.errors));
        } else {
          dispatch({ type: ADMIN_DELETE_FACEBASE, facebaseUuid: facebaseUuid });
          doneBack && doneBack();
        }
      })
      .catch(err => {
        failBack && failBack(apiFailCallbackHandle(err.message, "facebase"));
      });
  };
}

export const updateAdminFacebaseUser = (
  facebaseId: string,
  user: *
): DispatchType => (dispatch: DispatchType) => {
  dispatch({
    type: ADMIN_UPDATE_FACEBASE_USER,
    user: user,
    facebaseId: facebaseId
  });
};
